import Button from '@/components/ui/button';

const ErrorState = ({ onRetry, message = "Couldn't load Swedish League" }) => (
  <div className="rounded-3xl border border-rose-400/40 bg-rose-500/10 p-8 text-center text-white">
    <p className="text-lg font-semibold">{message}</p>
    <p className="mt-2 text-sm text-white/80">
      Please check your connection or try again in a moment.
    </p>
    <div className="mt-4 flex justify-center">
      <Button onClick={onRetry}>Retry</Button>
    </div>
  </div>
);

export default ErrorState;
